<script>
import {Link} from "@inertiajs/vue3";

export default {
    name: "PrivacyPolicyAgreementLink",
    components: {Link}
}
</script>

<template>
    <p class="text-xs text-[#2D2D2D] font-medium">
        Оставляя заявку Вы соглашаетесь с
        <a :href="route('privacyPolicy')" target="_blank"
           class="hover-indigo-decor font-bold hover:text-indigo-600 transition">
            условиями
        </a>
        на обработку персональных данных.
    </p>
</template>

<style scoped lang="scss">

</style>
